import {Component} from "../../../gvf/js/component";

export class TabsComponent extends Component{
    constructor(scope,$root){
        super(scope,$root);
    }

    ready(){
        super.ready();

        this.$root.find(".nav-link").on(
            "shown.bs.tab",
            (ev)=>{
                const id = $(ev.currentTarget).attr("href").substr(1);
                // Replace instead of push, so "back" goes to the previous page and not to the previous tab
                window.history.replaceState(window.history.state,"","#"+id+"tab");
            }
        ).click(
            (ev)=>{
                const $link = $(ev.currentTarget);
                if($link.attr("href").indexOf("#")==0){
                    ev.preventDefault();
                    $(ev.currentTarget).tab("show");
                }
            }
        );

        let hash = window.location.hash;
        if(hash && hash.endsWith("tab")){
            hash = hash.substring(0,hash.length-3);
            this.$root.find("a[href=\""+hash+"\"]").tab("show");
        }
    }
}

